<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onClick('all', $event)" />
          <svg
            v-if="!isDeleted"
            class="tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none">
            <path
              d="M28.9884 48.9149C27.8809 52.3674 27.1346 64.054 26.8999 69.4656L45.2733 71.418C45.1308 62.4099 44.6445 40.9207 43.8391 27.0284C43.0336 13.136 38.2176 4.38827 35.9103 1.75092C35.5328 1.2029 34.5008 0.64119 33.3933 2.77847C32.0089 5.45007 31.3796 15.8282 31.2538 22.9182C31.1279 30.0082 30.3728 44.5992 28.9884 48.9149Z"
              v-bind:class="{ selected: isSelected('root_1') }"
              v-bind:fill="partColor['root_1'] || '#FFF'"
              v-on:click="onClick('root_1', $event)"
              v-on:keydown="onClick('root_1', $event)" />
            <path
              d="M40.2279 55.7924L40.2968 55.6033C40.4319 55.2321 40.4672 54.8344 40.4015 54.4448C38.1336 40.9896 38.0526 24.1719 37.5344 20.1087C37.4918 19.7745 37.3329 19.4801 37.1012 19.2355C36.8394 18.9591 36.4396 18.7795 36.159 19.0368C35.9197 19.2562 35.6871 19.6822 35.6724 20.509C35.4539 32.8219 35.0481 47.6474 33.7955 54.5701L33.664 55.3511C33.6081 55.6835 33.6775 56.0249 33.859 56.309C34.0256 56.57 34.2762 56.7663 34.5695 56.8655L34.8954 56.9759L35.7987 57.0924L37.1473 57.0936C37.4732 57.0938 37.7988 57.071 38.1216 57.0252L38.7061 56.9423C38.8463 56.9224 38.9847 56.8912 39.1199 56.8491C39.6339 56.6891 40.0437 56.2983 40.2279 55.7924Z"
              v-bind:class="{ selected: isSelected('central_canal') }"
              v-bind:fill="partColor['central_canal'] || '#FF82BE'"
              v-on:click="onClick('central_canal', $event)"
              v-on:keydown="onClick('central_canal', $event)" />
            <path
              d="M45.0973 97.1062L28.4683 97.2039C27.893 97.2073 27.3184 97.1624 26.7506 97.0697C26.4807 97.0256 26.212 96.9683 25.9698 96.8411C25.5715 96.6319 24.926 96.1868 24.3821 95.319C23.5773 94.035 23.5586 92.4415 23.5962 90.9266C23.6999 86.7467 24.1826 79.7248 25.5902 73.3701C25.9167 71.8959 26.3676 70.6002 26.8997 69.4655C28.8248 65.3606 31.8137 63.3624 33.8309 62.6398C34.4476 62.4188 35.1071 62.3755 35.7622 62.3755C37.025 62.3755 38.2972 62.5742 39.3742 63.2337C41.1384 64.3141 43.3694 66.2438 44.4681 69.0545C44.7421 69.7554 45.0119 70.5571 45.2731 71.4178C45.3229 71.5818 45.3717 71.7482 45.4195 71.9165C47.458 79.094 48.2312 86.6739 47.8661 94.1264C47.812 95.2315 47.4885 95.9701 47.1227 96.4382C46.6599 97.0305 45.8491 97.1062 45.0973 97.1062Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import TopToothSurface from '../TopToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    TopToothSurface,
  },
  mixins: [toothMixin],
  name: 'ToothUp1',
};
</script>

<style></style>
